// scrollingDiffuseMap.js
var ScrollingDiffuseMap = pc.createScript('ScrollingDiffuseMap');

ScrollingDiffuseMap.attributes.add('materialAsset', {
    type: 'asset'
});

ScrollingDiffuseMap.attributes.add('speed', {
    type: 'vec2'
});

ScrollingDiffuseMap.tmp = new pc.Vec2();

// initialize code called once per entity
ScrollingDiffuseMap.prototype.initialize = function() {
    // get the material that we will animate
    if (this.materialAsset) {
        this.material = this.materialAsset.resource;
    } 
};

// update code called every frame
ScrollingDiffuseMap.prototype.update = function(dt) {
    var tmp = ScrollingDiffuseMap.tmp;
    
    // Calculate how much to offset the texture
    // Speed * dt
    tmp.set(this.speed.x, this.speed.y);
    tmp.scale(dt);


    // Update the diffuse and normal map offset values
    this.material.diffuseMapOffset.add(tmp);
    this.material.update();
};


